module.exports = __webpack_public_path__ + "static/4-8166ad59941d52b17a01299e2dd35b06.png";